var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"title"},[_vm._v("各科目当前成长值")]),_c('div',{staticStyle:{"width":"95%","height":"36vh","min-height":"200px"},attrs:{"id":_vm.myId}})])}
var staticRenderFns = []

export { render, staticRenderFns }